import request from '@/utils/request'

// 数据埋点
export function buryingPoint(data) {
  return request({
    url: "/basic/dataCockpit/save/menu/useNum",
    method: 'post',
    data:data
  })
}


// 查询教职工数据
export function getStaffData(data) {
  return request({
    url: "/basic/dataCockpit/get/staffData",
    method: 'post',
    data:data
  })
}

// 查询区域数据
export function getAreaData(data) {
  return request({
    url: "/basic/dataCockpit/get/areaData",
    method: 'post',
    data:data
  })
}

// 查询平台权限列表
export function getPfpermission() {
  return request({
    url: "/basic/dataCockpit/get/pfPermission",
    method: 'get',
  })
}

// 查询学生数据
export function getStudentData(data) {
  return request({
    url: "/basic/dataCockpit/get/studentData",
    method: 'post',
    data:data
  })
}

// 导出学生
export function exportStudentData(data){
    return request({
        url:'/basic/dataCockpit/export/studentData',
        method:'post',
        responseType: 'blob',
        data:data
    })
}

// 导出职工
export function exportStaffData(data){
    return request({
        url:'/basic/dataCockpit/export/staffData',
        method:'post',
        responseType: 'blob',
        data:data
    })
}

// 导出区域数据
export function exportAreaData(data){
    return request({
        url:'/basic/dataCockpit/export/areaData',
        method:'post',
        responseType: 'blob',
        data:data
    })
}

// 查看整体趋势
export function getOverallTrend(data) {
  return request({
    url: `/basic/dataCockpit/get/data/trend?schoolId=${data.schoolId}&areaId=${data.areaId}`,
    method: 'get'
  })
}

// 查询学校数据
export function getSchoolData(data) {
  return request({
    url: "/basic/dataCockpit/get/schoolData",
    method: 'post',
    data:data
  })
}

// 导出学校数据
export function exportSchoolData(data){
    return request({
        url:'/basic/dataCockpit/export/schoolData',
        method:'post',
        responseType: 'blob',
        data:data
    })
}

// 数据总览 扇形区域数据
export function dataOverview(data) {
  return request({
    url: "/basic/dataCockpit/get/dataOverview/basic",
    method: 'post',
    data:data
  })
}

// 数据总览 - 平台教学数据 - 演示资源(教育云平台) 
export function teachData(data) {
  return request({
    url: "/edu/edu/dataCockpit/get/dataOverview/teachData",
    method: 'post',
    data:data
  })
}

// 数据总览 - 平台教学数据 - 课堂练习(教育云平台)
export function practice(data) {
  return request({
    url: "/edu/edu/dataCockpit/get/dataOverview/practice",
    method: 'post',
    data:data
  })
}

// 数据总览 - 平台教学数据 - 课前预习(教育云平台) 
export function preview(data) {
  return request({
    url: "/edu/edu/dataCockpit/get/dataOverview/preview",
    method: 'post',
    data:data
  })
}

// 数据总览 - 平台教学数据 - 课后任务(教育云平台) 
export function task(data) {
  return request({
    url: "/edu/edu/dataCockpit/get/dataOverview/task",
    method: 'post',
    data:data
  })
}


// 数据总览 - 软件使用数据(教育云平台) 
export function softwareData(data) {
  return request({
    url: "/basic/dataCockpit/get/dataOverview/softwareData",
    method: 'post',
    data:data
  })
}

// 数据总览 - 设备使用数据(教育云平台) 
export function equipmentData(data) {
  return request({
    url: "/edu/edu/dataCockpit/get/dataOverview/equipmentData",
    method: 'post',
    data:data
  })
}

// 平台数据1(教育云平台)
export function platformData(data) {
  return request({
    url: "/basic/dataCockpit/get/platformData/first",
    method: 'post',
    data:data
  })
}
// 平台数据2(教育云平台)
export function platformDataSecond(data) {
  return request({
    url: "/basic/dataCockpit/get/platformData/second",
    method: 'post',
    data:data
  })
}
export function platformDataThird(data) {
  return request({
    url: "/basic/dataCockpit/get/platformData/third",
    method: 'post',
    data:data
  })
}
export function platformDataFourth(data) {
  return request({
    url: "/basic/dataCockpit/get/platformData/fourth",
    method: 'post',
    data:data
  })
}
export function platformDataFifth(data) {
  return request({
    url: "/basic/dataCockpit/get/platformData/fifth",
    method: 'post',
    data:data
  })
}

export function platformDataSix(data) {
  return request({
    url: "/edu/edu/dataCockpit/get/platformData/six",
    method: 'post',
    data:data
  })
}
export function platformDataSeventh(data) {
  return request({
    url: "/edu/edu/dataCockpit/get/platformData/seventh",
    method: 'post',
    data:data
  })
}


// 导出平台数据(教育云平台) 
export function exportPlatformData(data){
    return request({
        url:'/basic/dataCockpit/export/platformData',
        method:'post',
        responseType: 'blob',
        data:data
    })
}

// 软件数据(教育云平台) 
export function softData(data) {
  return request({
    url: "/basic/dataCockpit/get/softData",
    method: 'post',
    data:data
  })
}

// 软件数据排行
export function getScrollBar(pfId) {
  return request({
    url: `/basic/dataCockpit/get/scrollBar?pfId=${pfId}`,
    method: 'get'
  })
}

// 导出软件数据(教育云平台) 
export function exportSoftData(data){
    return request({
        url:'/basic/dataCockpit/export/softData',
        method:'post',
        responseType: 'blob',
        data:data
    })
}

// 平台数据 - 课堂练习、课前预习、课后任务布置次数排名(教育云平台) 
export function getRankList(data) {
  return request({
    url: "/edu/edu/dataCockpit/get/rank/list",
    method: 'post',
    data:data
  })
}

// 数据驾驶舱 - 设备数据(教育云平台) 
export function detailData(data) {
  return request({
    url: "/edu/edu/dataCockpit/get/equipment/detailData",
    method: 'post',
    data:data
  })
}

// 数据驾驶舱 - 设备数据 - 详情(教育云平台)
export function getdetailData(data) {
  return request({
    url: "/edu/edu/dataCockpit/get/equipment/detailData/particular",
    method: 'post',
    data:data
  })
}

// 导出设备数据(教育云平台)
export function exportDetailData(data){
    return request({
        url:'/edu/edu/dataCockpit/export/equipment/detailData',
        method:'post',
        responseType: 'blob',
        data:data
    })
}


// 导出设备详细数据(教育云平台) 
export function particular(data){
    return request({
        url:'/edu/edu/dataCockpit/export/equipment/detailData/particular',
        method:'post',
        responseType: 'blob',
        data:data
    })
}


// 保存用户退出时间
export function exitInfo(data) {
  return request({
    url: `/user/user/hero/save/exitInfo?loginInfoId=${data}`,
    method: 'post',
    data:data
  })
}




// WEBPACK FOOTER //
// ./src/api/cockpit.js